import React, { useEffect } from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { useState } from "react";
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import { setAllDataOfContact } from '../../Redux/Index';
import { useDispatch } from 'react-redux';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import InputLabel from '@mui/material/InputLabel';
import { useParams } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircularProgress from '@mui/material/CircularProgress';
import { updateOpportunityDataOfContact } from '../../Utility/UpdateOpportunityData/UpdateOpportunityData';
import { updateTaskDataOfContact } from '../../Utility/UpdateTaskData/UpdateTaskData';
import { addProdToOpp } from '../../Utility/AddProdToOpp/AddProdToOpp';
import { connect } from 'react-redux';
import Select from '@mui/material/Select';
import { Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import cusStyles from './OpportunityDetail.module.css';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate } from 'react-router-dom';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import { loginTimeOutAndRedirectHandler } from '../../Utility/LoginTimeOutAndRedirectHandler/LoginTimeOutAndRedirectHandler';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Backdrop from '@mui/material/Backdrop';
import FormHelperText from '@mui/material/FormHelperText';
import RelatedTaskDisplay from '../RelatedTaskDisplay/RelatedTaskDisplay';
import RelatedTaskEdit from '../RelatedTaskEdit/RelatedTaskEdit';

const mapStateToPropsForAllData = state => {
  return {
    allDataOfContact: state.allDataOfUser.allDataOfContact
  }
}

function OpportunityDetail({ allDataOfContact }) {

  // sessionStorage.setItem("Pdsk21D34Rl98", false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { id } = useParams();

  const originalId = id.substring(9, id.length - 4);

  const [isDataSubmitting, setIsDataSubmitting] = useState(false);
  const [isProdOfOppSubmitting, setIsProdOfOppSubmitting] = useState(false);
  const [opportunityNameError, setOpportunityNameError] = useState(false);
  const [closeDateError, setCloseDateError] = useState(false);
  const [stageNameError, setStageNameError] = useState(false);
  const [productNameError, setProductNameError] = useState(false);
  const [priceBookNameError, setPriceBookNameError] = useState(false);
  const [productQuantityError, setProductQuantityError] = useState(false);
  const [isSaveButtonClicked, setIsSaveButtonClicked] = useState(false);
  const [isSaveButtonClicked2, setIsSaveButtonClicked2] = useState(false);
  const [isPopupOpened, setIsPopupOpened] = useState(false);
  const [isPopupOpened2, setIsPopupOpened2] = useState(false);
  const [updatingTaskData, setUpdatingTaskData] = useState("");
  const [taskAndStageDataSubmitted, setTaskAndStageDataSubmitted] = useState(false);
  const [the9ThStage, setThe9ThStage] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [opportuniyData, setOpportunityData] = useState({
    Id: originalId
  });
  const [productData, setProductData] = useState({});
  const [priceBookData, setPriceBookData] = useState({});
  const [selectedProductData, setSelectedProductData] = useState({ Name: "" });
  const [selectedPriceBookData, setSelectedPriceBookData] = useState({Name: "" });
  const [productQuantity, setProductQuantity] = useState(1);
  

  useEffect(() => {

    if((allDataOfContact) && (allDataOfContact.success)) {
      setIsLoading(false);
    }

    if(Object.keys(opportuniyData).length === 1) {
      if(allDataOfContact.data && allDataOfContact.data.Opportunities) {
        allDataOfContact.data.Opportunities.records.forEach((rowData) => {
          if(rowData.Id == originalId) {
            setOpportunityData(rowData);
            return;
          }
        });
      }
    } 

    if(Object.keys(productData).length === 0) {
      let productDataArr = [];
      if(allDataOfContact.data && allDataOfContact.data.Products) {
        allDataOfContact.data.Products.records.forEach((rowData) => {
          productDataArr.push(rowData);
        });
      }
      setProductData(productDataArr);
    } 

    if(Object.keys(priceBookData).length === 0) {
      let priceBookDataArr = [];
      if(allDataOfContact.data && allDataOfContact.data.PriceBooks) {
        allDataOfContact.data.PriceBooks.records.forEach((rowData) => {
          priceBookDataArr.push(rowData);
        });
      }
      setPriceBookData(priceBookDataArr);
    } 

    if(opportuniyData.StageName == "Closed Won" || opportuniyData.StageName == "Closed Lost") {
      if(!the9ThStage) {
        setThe9ThStage(true);
      }
    }
    
  }, [allDataOfContact, isLoading, opportuniyData]);

  // Input field value handler start

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setOpportunityData({
      ...opportuniyData,
      [name]: value,
    });
    
  };

  // Input field value handler end

  // Input field error handler start

  const opportunityNameFieldErrorHandler = (e) => {
    const { name, value } = e.target;
    if(name=="Name" && value=="") {
      setOpportunityNameError(true);
    } else {
      setOpportunityNameError(false);
    }
  }

  const closeDateFieldErrorHandler = (e) => {
    const { name, value } = e.target;
    if(name=="CloseDate" && value=="") {
      setCloseDateError(true);
    } else {
      setCloseDateError(false);
    }
  }

  const stageFieldErrorHandler = (e) => {
    const { name, value } = e.target;
    if(name=="StageName" && (value=="--None--" || value=="Select a Closed Stage ...")) {
      setStageNameError(true);
    } else {
      setStageNameError(false);
    }
  }

  const productNameFieldErrorHandler = (e) => {
    const { name, value } = e.target;
    if(name=="Name" && (value=="--None--")) {
      setProductNameError(true);
    } else {
      setProductNameError(false);
    }
  }

  // Input field error handler end

  // Input field value handler start

  const handleInputChange2 = (e) => {
    const { name, value } = e.target;

    setSelectedProductData({
      [name]: value
    });
    
  };

  // Input field value handler end

  // Input field error handler start

  const priceBookNameFieldErrorHandler = (e) => {
    const { name, value } = e.target;
    if(name=="Name" && (value=="--None--")) {
      setPriceBookNameError(true);
    } else {
      setPriceBookNameError(false);
    }
  }

  const priceQualityFieldErrorHandler = (e) => {
    const { name, value } = e.target;
    if(name=="ProductQuanitity" && (value <= 0 || value == "")) {
      setProductQuantityError(true);
    } else {
      setProductQuantityError(false);
    }
  }

  // Input field error handler end

  // Input field value handler start

  const handleInputChange3 = (e) => {
    const { name, value } = e.target;
    setSelectedPriceBookData({
      [name]: value
    });
  };

  const handleInputChange4 = (e) => {
    const { name, value } = e.target;
    setProductQuantity(value);
  };

  const handleInputChange5 = (e) => {
    const { name, value } = e.target;

    setUpdatingTaskData({
      ...updatingTaskData,
      [name]: value
    });
    
  };

  // Input field value handler end

  // Opportunity submit func start

  function submitOpportunityData(isChangedByStageBar) {
    if(isChangedByStageBar) {
      setTaskAndStageDataSubmitted(true);
    }
    loginTimeOutAndRedirectHandler(updateOpportunityDataOfContact, opportuniyData, dispatch, setAllDataOfContact, navigate, "/", "Opportunity detail updated!", setIsDataSubmitting, "/Opportunities", isChangedByStageBar);
  }

  // Opportunity submit func end

   let opportunityStageVal = ["Prospecting", "Qualification", "Needs Analysis", "Value Proposition", "Id. Decision Makers", "Perception Analysis", "Proposal/Price Quote", "Negotiation Review", "Closed"];
  
  let targetCount = opportunityStageVal.indexOf(opportuniyData.StageName);
  let isStageBoxNeeded = false;
  let isStageBarNeeded = false;

  // Input fiele value handler start

  function stageNameValueChanger(stageValue) {
    setOpportunityData({
      ...opportuniyData,
      StageName: stageValue,
    });
    if(stageValue == "Closed") {
      setThe9ThStage(true);
    } else {
      setThe9ThStage(false);
    }
  }

  // Input field value handler end

  let prodDetails = opportuniyData?.prodDetails?.filter(value => value !== null);

  // Product and task submit func start

  function submitProdDataOfOpp() {

    console.log(selectedProductData);
    console.log(selectedPriceBookData);
    console.log(productQuantity);

    loginTimeOutAndRedirectHandler(addProdToOpp, { ProductId: selectedProductData.Name, PriceBookId: selectedPriceBookData.Name, Quantity: productQuantity, OpportunityId: opportuniyData.Id }, dispatch, setAllDataOfContact, navigate, "/", "Product Added to the Opportunity!", setIsProdOfOppSubmitting, "");

  }

  function submitTaskData() {
    setTaskAndStageDataSubmitted(true);
    loginTimeOutAndRedirectHandler(updateTaskDataOfContact, updatingTaskData, dispatch, setAllDataOfContact, navigate, "/", "Task detail updated!", setIsDataSubmitting, "");
  }

  // Product and task submit func end

  let taskDataFound = false;


  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1, textAlign: 'center', marginLeft: 2, marginBottom: 2, fontWeight: 'bold' }}
            >
              Opportunity Detail
            </Typography>
        <CssBaseline />
        { Object.keys(opportuniyData).length === 1 ?  <Box sx={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', marginTop: '20px'  }}><CircularProgress /></Box> : <Box
          sx={{
            marginTop: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
            {/* Opportunity stage bar start */}
          <Grid container xs={12} style={{ backgroundColor: "white", padding: "10px 5px" }}>

          <Grid item xs={9.25}>

          <div className={cusStyles.progressBarContainer}>
            { opportunityStageVal.map((stageVal, index) => {
              if(targetCount >= index) {
                isStageBoxNeeded = true;
                isStageBarNeeded = true;
              } else {
                isStageBoxNeeded = false;
                isStageBarNeeded = false;
              }
              
              if(targetCount == -1 && opportuniyData.StageName != "--None--") {
                isStageBoxNeeded = true;
                isStageBarNeeded = true;
              }
              return <>
              <Tooltip title={stageVal} arrow>
              <div onClick={(e) => {
                stageFieldErrorHandler(e);stageNameValueChanger(stageVal);
              }} className={`${cusStyles.progressBarItem} ${isStageBoxNeeded ? cusStyles.progressBarItem_Active : ""}`}><p className={cusStyles.progressBarItemText}>{index+1}</p></div>
              </Tooltip>
              { index != 8 ? <div className={`${cusStyles.progressBarLine} ${((isStageBarNeeded) && (stageVal != opportuniyData.StageName)) ? cusStyles.progressBarLine_Active : ""}`}></div> : "" }
              </>
            }) }
            
            <Backdrop
              sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={isPopupOpened}
              onClick={() => {
                return;
              }}
            >
            <Box
            sx={{
              display: 'flex',
              position: 'absolute',
              top: "10px",
              zIndex: 2,
              flexWrap: 'wrap',
              '& > :not(style)': {
                m: 1,
                width: '400px',
                height: '300px',
              },
            }}
             >
            <Paper elevation={1} >
            <Typography variant="h6" component="h1" gutterBottom style={{ fontWeight: 'bold', marginTop: "10px" }}>
              Close This Opportunity
            </Typography>
            <Divider variant="hr" style={{ borderBottom: "2px solid gray" }} />
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <InputLabel htmlFor="stageName" style={{ textAlign: "left", marginBottom: "1rem" }}><span style={{ color: 'red' }}>*</span> Stage</InputLabel>
              <Select
                margin="normal"
                fullWidth
                type="select"
                id="stageName"
                value={(opportuniyData.StageName == "Closed" || opportuniyData.StageName == "--None--") ? "Select a Closed Stage ..." : (opportuniyData.StageName == "Closed Won" || opportuniyData.StageName == "Closed Lost") ? opportuniyData.StageName : "Select a Closed Stage ..." }
                name="StageName"
                placeholder="Select Stage"
                onChange={(e) => { stageFieldErrorHandler(e);handleInputChange(e) }}
                style={{ textAlign: "left" }}
              >
                <MenuItem value={"Select a Closed Stage ..."}>Select a Closed Stage ...</MenuItem>
                <MenuItem value={"Closed Won"}>Closed Won</MenuItem>
                <MenuItem value={"Closed Lost"}>Closed Lost</MenuItem>
              </Select>
              { (opportuniyData.StageName != "Closed Won" && opportuniyData.StageName != "Closed Lost" && isSaveButtonClicked == true) ? <Stack sx={{ width: '100%', marginTop: "5px" }} spacing={2}>
                <Alert severity="error">Select the stage</Alert>
              </Stack> : "" }
              <Grid container spacing={2} justify="flex-end" style={{ marginTop: "8px", marginLeft: "160px" }}>
              <Grid item>
                <Button variant="outlined" onClick={ () => { setIsPopupOpened(false) }}>Cancel</Button>
              </Grid>
              <Grid item>
                <Button variant="contained" onClick={(opportuniyData.StageName != "Closed Won" && opportuniyData.StageName != "Closed Lost") ? () => { setIsPopupOpened(true); setIsSaveButtonClicked(true); } : () => { setIsPopupOpened(false); setIsSaveButtonClicked(false);submitOpportunityData(true); }}>Save</Button>
              </Grid>
            </Grid>
              </Container>
            </Paper>
            </Box>
            </Backdrop>

          </div>

          </Grid>
          <Grid item xs={2.75}><Button variant="contained" style={{ textTransform: 'none' }} startIcon={<CheckCircleIcon/>} onClick={the9ThStage ? () => { setIsPopupOpened(true) } : (opportuniyData.StageName == "--None--" || opportuniyData.StageName == "Closed") ? null : () => {submitOpportunityData(true)}}>{ the9ThStage ? ((opportuniyData.StageName == "Closed" || opportuniyData.StageName == "Select a Closed Stage ...") ? "Select Closed Stage" : "Change Closed Stage") : "Mark as Current Stage" }</Button></Grid>

          </Grid>
          {/* Opportunity stage bar end */}

          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={8} style={{ borderRight: (Object.keys(opportuniyData).length === 1 ? "" : "3px solid black"), marginTop: "1rem" }}>
          <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="name" style={{ textAlign: "left" }}><span style={{ color: 'red' }}>*</span> Name</InputLabel>
            <TextField
              margin="normal"
              fullWidth
              id="name"
              type="text"
              required
              error={opportunityNameError}
              name="Name"
              placeholder="Enter Opportunity Name"
              helperText={opportunityNameError ? 'Name is required!' : ''} 
              value={opportuniyData.Name == null ? "" : opportuniyData.Name}
              onChange={(e) => { opportunityNameFieldErrorHandler(e);handleInputChange(e); }}
            />
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="stageName" style={{ textAlign: "left", marginBottom: "1rem" }}><span style={{ color: 'red' }}>*</span> Stage Name</InputLabel>
              <Select
                margin="normal"
                fullWidth
                required
                type="select"
                id="stageName"
                value={(opportuniyData.StageName == "Closed" || opportuniyData.StageName == "Select a Closed Stage ...") ? "--None--" : opportuniyData.StageName}
                name="StageName"
                placeholder="Select Stage"
                error={(stageNameError == false && opportuniyData.StageName == "Closed") ? true: stageNameError}
                onChange={(e) => { stageFieldErrorHandler(e);handleInputChange(e); }}
                style={{ textAlign: "left" }}
              >
                <MenuItem value={"--None--"}>--None--</MenuItem>
                <MenuItem value={"Prospecting"}>Prospecting</MenuItem>
                <MenuItem value={"Qualification"}>Qualification</MenuItem>
                <MenuItem value={"Needs Analysis"}>Needs Analysis</MenuItem>
                <MenuItem value={"Value Proposition"}>Value Proposition</MenuItem>
                <MenuItem value={"Id. Decision Makers"}>Id. Decision Makers</MenuItem>
                <MenuItem value={"Perception Analysis"}>Perception Analysis</MenuItem>
                <MenuItem value={"Proposal/Price Quote"}>Proposal/Price Quote</MenuItem>
                <MenuItem value={"Negotiation Review"}>Negotiation Review</MenuItem>
                <MenuItem value={"Closed Won"}>Closed Won</MenuItem>
                <MenuItem value={"Closed Lost"}>Closed Lost</MenuItem>
              </Select>
              <FormHelperText style={{ marginLeft: "10px", color: "#DA2F2F" }}>{ (stageNameError == true || opportuniyData.StageName == "Closed") ? ' Stage is required!' : '' }</FormHelperText>
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="leadSource" style={{ textAlign: "left", marginBottom: "1rem" }}>Lead Source</InputLabel>
                <Select
                margin="normal"
                fullWidth
                type="select"
                id="leadSource"
                value={(opportuniyData.LeadSource == "--None--" || opportuniyData.LeadSource == null) ? "--None--" : opportuniyData.LeadSource}
                name="LeadSource"
                placeholder="Select Lead Source"
                onChange={handleInputChange}
                style={{ textAlign: "left" }}
              >
                <MenuItem value={"--None--"}>--None--</MenuItem>
                <MenuItem value={"Web"}>Web</MenuItem>
                <MenuItem value={"Phone Inquiry"}>Phone Inquiry</MenuItem>
                <MenuItem value={"Partner Refferal"}>Partner Refferal</MenuItem>
                <MenuItem value={"Purchased List"}>Purchased List</MenuItem>
                <MenuItem value={"Other"}>Other</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="type" style={{ textAlign: "left", marginBottom: "1rem" }}>Type</InputLabel>
                <Select
                margin="normal"
                fullWidth
                type="select"
                id="type"
                value={(opportuniyData.Type == "--None--" || opportuniyData.Type == null) ? "--None--" : opportuniyData.Type}
                name="Type"
                placeholder="Select Type"
                onChange={handleInputChange}
                style={{ textAlign: "left" }}
              >
                <MenuItem value={"--None--"}>--None--</MenuItem>
                <MenuItem value={"Existing Customer - Upgrade"}>Existing Customer - Upgrade</MenuItem>
                <MenuItem value={"Existing Customer - Replacement"}>Existing Customer - Replacement</MenuItem>
                <MenuItem value={"Existing Customer - Downgrade"}>Existing Customer - Downgrade</MenuItem>
                <MenuItem value={"New Customer"}>New Customer</MenuItem>
                <MenuItem value={"Good"}>Good</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="closeDate" style={{ textAlign: "left" }}><span style={{ color: 'red' }}>*</span> Close Date</InputLabel>
            <TextField
              margin="normal"
              required
              fullWidth
              type="date"
              error={closeDateError}
              id="closeDate"
              helperText={closeDateError ? 'Close date is required!' : ''} 
              name="CloseDate"
              value={opportuniyData.CloseDate == null ? "" : opportuniyData.CloseDate}
              placeholder="Enter Close Date"
              onChange={(e) => { closeDateFieldErrorHandler(e);handleInputChange(e); }}
            />
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="trackingNumber" style={{ textAlign: "left" }}>Tracking Number</InputLabel>
            <TextField
              margin="normal"
              fullWidth
              type="number"
              id="trackingNumber"
              name="TrackingNumber__c"
              value={opportuniyData.TrackingNumber__c == null ? "" : opportuniyData.TrackingNumber__c}
              placeholder="Enter Tracking Number"
              onChange={handleInputChange}
            />
            </Grid>
            
            <Grid item xs={12}>
            <Divider style={{ backgroundColor: "#1976D2", height: "1.5px" }} />
            </Grid>

            <Grid item xs={12}>
            <Typography
              component="h6"
              variant="subtitle1"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1, marginTop: "1rem", textAlign: "left", marginBottom: 0.5, textDecoration: "underline" }}
            >
              Add Product
            </Typography>
            </Grid>

            <Grid container xs={12} style={{ padding: "0px 15px" }}>
            <Grid item xs={12} md={3.5} style={{ margin: "auto 5px" }}>
            <InputLabel htmlFor="productName" style={{ textAlign: "left", marginBottom: "0.5rem" }}><span style={{ color: 'red' }}>*</span> Product Name</InputLabel>
                <Select
                margin="normal"
                fullWidth
                required
                type="select"
                id="productName"
                value={(selectedProductData.Name == "--None--" || selectedProductData.Name == "") ? "--None--" : selectedProductData.Name}
                name="Name"
                error={(productNameError == false && selectedProductData.Name == "--None--") ? true: productNameError}
                placeholder="Select Product Name"
                onChange={(e) => { productNameFieldErrorHandler(e);handleInputChange2(e); }}
                style={{ textAlign: "left" }}
              >
                <MenuItem value={"--None--"}>--None--</MenuItem>
                { allDataOfContact?.data?.Products?.records?.map((rowData) => {
                  return <MenuItem value={rowData.Id}>{rowData.Name}</MenuItem>

                }) }
              </Select>
              <FormHelperText style={{ marginLeft: "10px", color: "#DA2F2F" }}>{ (productNameError == true || selectedProductData.Name == "--None--") ? ' Product name is required!' : '' }</FormHelperText>
            </Grid>
            <Grid item xs={12} md={3.5} style={{ margin: "auto 5px" }}>
            <InputLabel htmlFor="productBookName" style={{ textAlign: "left", marginBottom: "0.5rem" }}><span style={{ color: 'red' }}>*</span> Price Book Name</InputLabel>
                <Select
                margin="normal"
                fullWidth
                required
                type="select"
                id="productBookName"
                value={(selectedPriceBookData.Name == "--None--" || selectedPriceBookData.Name == "") ? "--None--" : selectedPriceBookData.Name}
                name="Name"
                error={(priceBookNameError == false && selectedPriceBookData.Name == "--None--") ? true: priceBookNameError}
                placeholder="Select Price Book Name"
                onChange={(e) => { priceBookNameFieldErrorHandler(e);handleInputChange3(e); }}
                style={{ textAlign: "left" }}
              >
                <MenuItem value={"--None--"}>--None--</MenuItem>
                { allDataOfContact?.data?.PriceBooks?.records?.map((rowData) => {
                  return <MenuItem value={rowData.Id}>{rowData.Name}</MenuItem>

                }) }
              </Select>
              <FormHelperText style={{ marginLeft: "10px", color: "#DA2F2F" }}>{ (priceBookNameError == true || selectedPriceBookData.Name == "--None--") ? ' Price Book name is required!' : '' }</FormHelperText>
            </Grid>
            <Grid item xs={12} md={2.8} style={{ margin: "auto 5px" }}>
            <InputLabel htmlFor="productQuantity" style={{ textAlign: "left", marginBottom: "0rem"  }}><span style={{ color: 'red' }}>*</span> Product Quantity</InputLabel>
            <TextField
              margin=""
              fullWidth
              required
              type="number"
              id="productQuantity"
              style={{ marginTop: "0.5rem" }}
              name="ProductQuanitity"
              value={(productQuantity == null || productQuantity == "" || productQuantity == " ") ? "" : productQuantity}
              placeholder="Enter Quantity"
              onChange={(e) => { priceQualityFieldErrorHandler(e);handleInputChange4(e); }}
            />
            <FormHelperText style={{ marginLeft: "10px", color: "#DA2F2F" }}>{ (productQuantityError == true || productQuantity == null || productQuantity == "" || productQuantity == " ") ? ' Product quantity is required!' : '' }</FormHelperText>
            </Grid>
            <Grid item xs={12} md={1} style={{ margin: "auto 5px" }}>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              style={{ height: "55px", marginTop: "43px" }}
              onClick={() => { setIsProdOfOppSubmitting(true);submitProdDataOfOpp(); }}
              disabled={ (productData.Name == "--None--" || priceBookData.Name == "--None--" || productQuantity == null || productQuantity == "" || productQuantity == " " || productQuantity <= 0 || selectedProductData?.Name == "" || selectedPriceBookData?.Name == "" || selectedProductData?.Name == "--None--" || selectedPriceBookData?.Name == "--None--") ? true : false }
            >
              { isProdOfOppSubmitting ? <CircularProgress size={24} style={{ color: "white" }} /> : "Add" }
            </Button>
            </Grid>
            </Grid>

            <Grid item xs={12}>
            <Divider style={{ backgroundColor: "#1976D2", height: "1.5px" }} />
            </Grid>

            <Grid container xs={12} style={{ padding: "0px 15px" }}>
            <Typography
              component="h6"
              variant="subtitle1"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1, textAlign: 'left', marginTop: "1rem", textDecoration: "underline", marginLeft: "0.5rem" }}
            >
              Products
            </Typography>
            { Object.keys(opportuniyData).length === 1 ? <Box sx={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', marginTop: '20px'  }}>
            <CircularProgress />
          </Box>  : ((opportuniyData?.prodDetails?.length) != 0 ? <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold' }}>S.No</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Name</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Quantity</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Price</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Total Price</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
              { prodDetails?.map((oppProdData, index) => {

                
                return (<TableRow key={oppProdData.Name}>
                  <TableCell>{index+1}.</TableCell>
                  <TableCell>{oppProdData.Name.replace(opportuniyData.Name, "")}</TableCell>
                  <TableCell>{oppProdData.Quantity}</TableCell>
                  <TableCell>{oppProdData.UnitPrice}</TableCell>
                  <TableCell>{oppProdData.TotalPrice}</TableCell>
                </TableRow>)
              })}

              </TableBody>
            </Table>  : <div style={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', marginTop: '20px'}}><p>No Records Found!</p></div>) }
            </Grid>

            <Grid item xs={2} md={6} lg={8}>
            
            </Grid>
            <Grid item xs={5} md={3} lg={2}>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              onClick={() => { setIsDataSubmitting(true);submitOpportunityData(false) }}
              disabled={ (opportuniyData.Name == "" || opportuniyData.StageName == "--None--" || opportuniyData.StageName == "Closed" || opportuniyData.CloseDate == "" || opportuniyData.StageName == "Select a Closed Stage ...") ? true : false }
            >
              { isDataSubmitting ? <CircularProgress size={24} style={{ color: "white" }} /> : "Update" }
            </Button>
            </Grid>
            <Grid item xs={5} md={3} lg={2}>
            <Link to="/Opportunities" style={{ textDecoration: 'none', color: 'transparent' }}>
            <Button
              type="submit"
              fullWidth
              variant="outlined"
              sx={{ mt: 3, mb: 2 }}
            >
              Cancel
            </Button>
            </Link>
            </Grid>
            </Grid>
            </Container>
            </Grid>
            {/* Related task start */}
            <Grid item xs={4}>
              <RelatedTaskDisplay objData={opportuniyData} idtype="WhatId" allDataOfContact={allDataOfContact} setUpdatingTaskData={setUpdatingTaskData} setIsPopupOpened2={setIsPopupOpened2} />
              {/* Related task start */}
              {/* Related task form start */}
              <RelatedTaskEdit isPopupOpened2={isPopupOpened2} updatingTaskData={updatingTaskData} isSaveButtonClicked2={isSaveButtonClicked2} handleInputChange5={handleInputChange5} setIsPopupOpened2={setIsPopupOpened2} setIsSaveButtonClicked2={setIsSaveButtonClicked2} submitTaskData={submitTaskData} />
            {/* Related task form end */}

            </Grid>
            </Grid>
          </Grid>
        </Box> }

        <Backdrop
              sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={taskAndStageDataSubmitted}
              onClick={() => {
                return;
              }}
            >
            <Box
            sx={{
              display: 'flex',
              position: 'absolute',
              top: "40%",
              zIndex: 2,
              flexWrap: 'wrap',
              '& > :not(style)': {
                m: 1,
                width: '80px',
                height: '80px',
              },
            }}
             >
            <CircularProgress style={{ color: "white" }} />
            </Box>
            </Backdrop> 

      </Container>
  )
}

export default connect(mapStateToPropsForAllData)(OpportunityDetail);